import type { Theme } from '@mui/material';

const formLabel: Theme['components'] = {
  MuiFormLabel: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.subtitle1,
        color: 'var(--mui-palette-text-primary)',
        marginBottom: '8px',
      }),
    },
  },
};

export default formLabel;
